export default __webpack_public_path__ + "lee.9a19be06.png";